import styled from 'styled-components';
import { grayDarker } from '@bufferapp/ui/style/colors';

export const PaywallWrapper = styled.div`
  margin: 0;
  min-height: 100%;
  padding: 24px 32px;

  &:after {
    content: ' ';
    position: absolute;
    bottom: 40%;
    left: 0%;
    margin-left: -14px;
    border-width: 7px;
    border-style: solid;
    border-color: transparent white transparent transparent;
  }
`;

export const PaywallImage = styled.img`
  width: 100%;
  object-fit: none;
`;

export const PlusText = styled.p`
  margin: '0 0 5px';
  font-weight: 700;
  color: ${grayDarker};
`;

export const PaywallContent = styled.div`
  margin: 16px 0 0 0;
  height: calc(100% - 250px);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
